import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpChartLegendItemComponent from './adpChartLegendItem.component';

let adpChartLegendItemModule = angular.module('adpChartLegendItem', [
  uiRouter
])

.component('adpChartLegendItem', adpChartLegendItemComponent)

.name;

export default adpChartLegendItemModule;



// WEBPACK FOOTER //
// ./src/app/components/adpChartLegendItem/adpChartLegendItem.js